export default __webpack_public_path__ + "static/media/sticker-P.e09405b0.png";